const it = {
    // generic
    "close": "Chiudi",
    "loading": "Caricamento...",

    // OPS page
    "public.ops.404.title": "Ops, qualcosa è andato storto.",
    "public.ops.404.subtitle": "La pagina che stai cercando non esiste più o non è stata trovata.",

    "public.ops.country_disabled.title": "Paese non disponibile",
    "public.ops.country_disabled.subtitle": "Ci dispiace, ma il programma non è ancora disponibile nel tuo paese.",

    "public.ops.country_mismatch.title": "Paese non corrispondente",
    "public.ops.country_mismatch.subtitle":
        "Il paese associato al tuo profilo loyalty non corrisponde a quello del tuo account B2C. Contatta il supporto per ricevere assistenza.",

    "public.ops.generic.title": "Si è verificato un errore.",
    "public.ops.generic.subtitle": "Scopri le condizioni per partecipare al programma fedeltà GEWISS Passion.",

    "public.ops.cta.label": "Torna indietro",

    // welcome page
    "public.welcome.title": "Benvenuto su",
    "public.welcome.subtitle": "Installa prodotti Gewiss e accumula punti per accedere al catalogo premi.",
    "public.welcome.cta.login": "Accedi",
    "public.welcome.cta.signup": "Crea un account",
    "public.welcome.cta.discover": "Scopri di più",
    "public.welcome.howto.title": "Come funziona Gewiss Passion?",
    "public.welcome.howto.lead": "Ottenere premi è semplice e veloce.",
    "public.welcome.howto.step1.title": "1. Acquista prodotti Gewiss",
    "public.welcome.howto.step1.text": "Ogni acquisto ti permette di guadagnare punti e ti avvicina ai tuoi premi preferiti.",
    "public.welcome.howto.step2.title": "2. Carica la tua fattura",
    "public.welcome.howto.step2.text":
        "Scatta una foto o carica il PDF: verifica rapida, punti accreditati in pochi giorni e tutto gestito dal portale o dalla web app.",
    "public.welcome.howto.step3.title": "3. Partecipa alle sfide",
    "public.welcome.howto.step3.text":
        "Rispondi ai sondaggi, guarda video di formazione e metti alla prova le tue conoscenze con i quiz: ogni attività è un’ulteriore opportunità per guadagnare punti. Consulta regolarmente l’app per restare aggiornato sulle sfide in corso.",
    "public.welcome.howto.step4.title": "4. Scegli e richiedi il tuo premio",
    "public.welcome.howto.step4.text":
        "Hai raggiunto il tuo obiettivo di punti? Sfoglia il catalogo e richiedi il tuo premio quando vuoi. Tocca a te.",

    // onboard
    "public.onboard.title": "Completa il tuo profilo loyalty",
    "public.onboard.subtitle": "Verifica e completa le informazioni della tua azienda per finalizzare la registrazione",
    "public.onboard.form.submit.label": "Accedi al programma",
    "public.onboard.form.submitting.label": "Accedi al programma ...",

    "public.onboard.form.labels.vat": "Partita IVA *",
    "public.onboard.form.labels.business_name": "Ragione sociale *",
    "public.onboard.form.labels.business_email": "Email *",
    "public.onboard.form.descriptions.business_email":
        "Inserisci l’indirizzo email dell’azienda. Lo utilizzeremo per informarti sull’adesione al programma.",

    "public.onboard.form.labels.t_and_c": "",
    "public.onboard.form.labels.t_and_c_text":
        "Dichiaro di aver preso visione della <a href='https://www.gewiss.com/it/it/about-gewiss/privacy-policy' target='_blank'>Privacy Policy</a> e di accettare il <a href='https://cdn.jnext-it.jakala.cloud/IOJ3HsZEXv8qP/ptir6BAgERQzJ/assets/docs/fr/Rules.pdf' target='_blank'>regolamento</a>.",
    "public.onboard.form.labels.agree": "Conferma",
    "public.onboard.form.labels.decline": "Non accetto",

    "public.onboard.form.validation.vat_required": "La partita IVA è obbligatoria",
    "public.onboard.form.validation.vat_too_short": "Partita IVA non valida",
    "public.onboard.form.validation.business_name_required": "La ragione sociale è obbligatoria",
    "public.onboard.form.validation.business_name_too_short": "La ragione sociale è troppo corta",
    "public.onboard.form.validation.business_email_required": "L’indirizzo email è obbligatorio",
    "public.onboard.form.validation.business_email_invalid": "Indirizzo email non valido",
    "public.onboard.form.validation.gdpr_required": "È necessario accettare i termini e condizioni",
    "public.onboard.form.validation.field_required": "Campo obbligatorio",

    "public.onboard.form.feedback.vat_invalid.title": "Partita IVA non valida.",
    "public.onboard.form.feedback.vat_invalid.message": "Partita IVA non valida",
    "public.onboard.form.feedback.vat_invalid.label": "Chiudi",
    "public.onboard.form.feedback.vat_already_used.message": "Non è possibile completare la registrazione. La Partita IVA inserita risulta già registrata.",

    "public.onboard.form.feedback.generic_error.title": "Operazione non riuscita.",
    "public.onboard.form.feedback.generic_error.label": "Chiudi",
    "public.onboard.form.feedback.generic_error.message": "Riprova.",

    // footer
    "public.footer.text":
        "Sede legale: Via Domenico Bosatelli 1 - 24069 CENATE SOTTO BG – Italia - Codice fiscale e Partita IVA, iscritta alla Camera di Commercio di Bergamo con numero: 00385040167 - Copyright ©2026 - Capitale sociale interamente versato €60.010.000,00. Società soggetta alla direzione e coordinamento di Polifin S.p.A.",
    "public.footer.links.rules.label": "Regolamento",
    "public.footer.links.rules.link": "IOJ3HsZEXv8qP/ptir6BAgERQzJ/assets/docs/fr/Rules.pdf",
    "public.footer.links.privacy.label": "Privacy Policy",
    "public.footer.links.privacy.link": "https://www.gewiss.com/it/it/about-gewiss/privacy-policy",
    "public.footer.links.cookie.label": "Cookie Policy",

    "footer:unsubscribe_program": "Disiscriviti dal programma",
    "unsubscribe:modal:title": "Conferma disiscrizione",
    "unsubscribe:modal:text": "Stai per inviare una richiesta di disiscrizione dal programma.",
    "unsubscribe:modal:fineprint": "La richiesta verrà presa in carico entro {{days}} giorni lavorativi.",
    "unsubscribe:modal:cta": "Conferma disiscrizione",

    "unsubscribe:modal:loading:title": "Invio richiesta in corso",
    "unsubscribe:modal:loading:text": "Stiamo inviando la tua richiesta di disiscrizione.",

    "unsubscribe:modal:success:title": "Richiesta inviata",
    "unsubscribe:modal:success:text": "La tua richiesta di disiscrizione è stata inviata correttamente.",
    "unsubscribe:modal:success:label": "Chiudi",

    "unsubscribe:modal:error:text": "Si è verificato un errore durante l'invio della richiesta. Riprova più tardi.",

    "public.language.modal.title": "Scegli la lingua",
    "public.language.open_picker": "Apri selettore lingua",
    "public.language.current_prefix": "Sei in",
    "public.language.change_country": "Cambia paese"
};

export default it;